import { Component, EventEmitter, Input, Output} from "@angular/core";
import { Activity } from "../../../../models/activity/activity";
import { Request } from '../../../../models/request/request';
import { ActivitiesService } from "../../../../services/activities.service";
import { KeyValueObject } from "../../../../models/core/KeyValueObject";
import { CompleteActivityResultPropertiesData } from "../../flow-components/complete-activity-result-properties/complete-activity-result-properties-data";
import { Subject, forkJoin } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { For1CService } from "../../../../services/for-1c.service";
import { DialogService } from "@progress/kendo-angular-dialog";
import { CompleteActivityResultPropertiesComponent } from "../../flow-components/complete-activity-result-properties/complete-activity-result-properties.component";
import { AppService } from "../../../../../app.service";
import { BaseFlowComponent } from "../../flow-components/base-flow-component/base-flow-component";
import { LookupService } from "../../../../services/lookup.service";
import { RequestsService } from "../../../../services/requests.service";
import { Attachment } from "../../../../models/attachment";
import { AttachmentsService } from "../../../../services/attachments.service";
import { UploadFileData } from "../../../../models/attachment/upload-file-data";
import { CompleteActivityRequiredAttachmentData } from "../../flow-components/complete-activity-required-attachment/complete-activity-required-attachment-data";
import { CompleteActivityRequiredAttachmentComponent } from "../../flow-components/complete-activity-required-attachment/complete-activity-required-attachment.component";
import { AttachmentTypeConfigurationsService } from "../../../../services/attachment-type-configurations.service";
import { CompleteActivitySummaryData, SummaryGeneralDevice } from "../../flow-components/complete-activity-summary/complete-activity-summary-data";
import { CompleteActivitySummaryComponent } from "../../flow-components/complete-activity-summary/complete-activity-summary.component";
import { NomenclatureService } from "../../../../services/nomenclature.service";
import { DeviceInfo } from "../../../../models/device/device-info";
import { NotificationType } from "../../../../../core/services/notification-type";
import { CompleteActivitySignatureContainerData } from "../../flow-components/complete-activity-signature-container/complete-activity-signature-container.data";
import { CompleteActivitySignatureContainerComponent } from "../../flow-components/complete-activity-signature-container/complete-activity-signature-container.component";
import { NotificationService } from "../../../../../core/services/notification.service";
import { CompleteActivityServiceOrChangeModel } from "../../../../models/activity/complete-activity-service-or-change.model";
import { CompleteActivitySavingResultComponent } from "../../flow-components/complete-activity-saving-result/complete-activity-saving-result.component";
import { CompleteActivitySavingResultData } from "../../flow-components/complete-activity-saving-result/complete-activity-saving-result.data";
import { ActivitySuccessResultWithoutDevicesFlowOrder } from "./activity-success-result-without-devices-flow-order";
import { CompleteActivityWithoutDevicesModel } from "../../../../models/activity/complete-activity-without-devices.model";

@Component({
    selector: 'activity-success-result-without-devices-flow-container',
    templateUrl: './activity-success-result-without-devices-flow-container.html',
    styleUrls: ['./activity-success-result-without-devices-flow-container.scss',
        '../../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss']
})
export class ActivitySuccessResultWithoutDevicesFlowContainer {
    flowOrdering = [];

    @Input() requestTypeId: number;
    @Input() nextActivityStatusId: number;
    @Input() activity: Activity;
    @Input() request: Request;
    @Input() activityWorkflowTransitionId: number;

    @Output() continue: EventEmitter<any> = new EventEmitter<any>();

    private _destroy$: Subject<boolean> = new Subject<boolean>();

    private useImageAnalyze: boolean = true;

    // переменные ui
    dataLoading: boolean = false;
    private currentOrderIndex: number = 0;
    private isForwardMovement: boolean = true;

    // данные для других окон
    private activityResults: KeyValueObject[] = [];
    private uploadedFiles: UploadFileData[] = [];
    private attachmentTypes: KeyValueObject[] = [];
    private unsetBIOReasons: KeyValueObject[] = [];

    constructor(
        private activitiesService: ActivitiesService,
        private requestsService: RequestsService,
        private attachmentsService: AttachmentsService,
        private attachmentTypeConfigurationsService: AttachmentTypeConfigurationsService,
        private for1CService: For1CService,
        private nomenclatureService: NomenclatureService,
        private lookupService: LookupService,
        private dialogService: DialogService,
        private appService: AppService,
        private notificationService: NotificationService) {
    }

    public ngOnDestroy(): void {
        this._destroy$.next(true);
        this._destroy$.complete();
    }

    ngOnInit(): void { 
        this.dataLoading = true;

        this.initializeFlow();

        this.activity.attachments.map(attachment => {
            this.loadFileData(attachment).then(file => {
                this.uploadedFiles.push(file);
            })
        });
        const requestUninstallDevices$ = this.requestsService.getRequestUninstallDevices(this.request.requestId);
        const erpContragentInfo$ = this.for1CService.getContragentInfo(this.request.customerContragentIntegraCode);
        const activityResults$ = this.activitiesService.getActivityResults(this.activity.activityId, this.nextActivityStatusId);
        const mobileNomenclatures$ = this.nomenclatureService.getPartnumberByName('SIM-карта');
        const requiredAttachmentTypes$ = this.attachmentTypeConfigurationsService.getRequiredAttachmentTypes(this.request.requestId, this.nextActivityStatusId);
        const attachmentTypes$ = this.lookupService.getData("attachment-types", null);
        const unsetBIOReasons$ = this.lookupService.getData("unset-bio-reasons", null);

        forkJoin(
                requestUninstallDevices$, 
                erpContragentInfo$, 
                activityResults$,
                mobileNomenclatures$, 
                attachmentTypes$,
                requiredAttachmentTypes$,
                unsetBIOReasons$)
            .pipe(takeUntil(this._destroy$))
            .subscribe((results) => {
                this.activityResults = results[2].map(x => new KeyValueObject(x.activityResultId, x.activityResult));

                this.attachmentTypes = results[4];
                let requiredAttachmentTypeIds: number[] = [];
                if (results[5].data != null && results[5].data.data && results[5].data.data.length > 0) {
                    results[5].data.data.forEach(x => { requiredAttachmentTypeIds = requiredAttachmentTypeIds.concat(x.attachmentTypes.map(at => at.attachmentTypeId)); });
                    requiredAttachmentTypeIds = requiredAttachmentTypeIds.filter((value, index, self) => {
                        return self.indexOf(value) === index;
                    });
                }

                this.unsetBIOReasons = results[6];

                this.initData();

                if (requiredAttachmentTypeIds.length > 0) {
                    requiredAttachmentTypeIds.forEach(id => this.addRequiredAttachmentFlowComponent(id));
                }
                this.removeLastDefaultItem(ActivitySuccessResultWithoutDevicesFlowOrder.requiredAttachmentsStep);

                this.dataLoading = false;
                
                this.openFlowComponent()
            });
    }

    initializeFlow() {
        this.flowOrdering = [
            {
                component: CompleteActivityResultPropertiesComponent,
                orderNumber: ActivitySuccessResultWithoutDevicesFlowOrder.completeActivityResultStep,
                data: null as CompleteActivityResultPropertiesData,
                title: "Результат работы"
            },
            {
                orderNumber: ActivitySuccessResultWithoutDevicesFlowOrder.requiredAttachmentsStep,
                data: new CompleteActivityRequiredAttachmentData,
                title: "Фото документов"
            },
            {
                orderNumber: ActivitySuccessResultWithoutDevicesFlowOrder.completeActivitySummaryStep,
                data: new CompleteActivitySummaryData,
                title: "Резюме"
            },
            {
                orderNumber: ActivitySuccessResultWithoutDevicesFlowOrder.completeActivitySignatureStep,
                data: new CompleteActivitySignatureContainerData,
                title: "Подпись"
            },
            {
                orderNumber: ActivitySuccessResultWithoutDevicesFlowOrder.saveResults,
                data: new CompleteActivitySavingResultData,
                title: "Сохранение результатов"
            }
        ];
    }

    initData() {
        this.initFlowOrderingData(ActivitySuccessResultWithoutDevicesFlowOrder.completeActivityResultStep, this.getCompleteActivityResultPropertiesData());
    }

    openFlowComponent() {
        switch (this.currentOrderNumber) {
            case ActivitySuccessResultWithoutDevicesFlowOrder.completeActivityResultStep:
                this.showFlowComponentDialog(CompleteActivityResultPropertiesComponent);
                break;

            case ActivitySuccessResultWithoutDevicesFlowOrder.requiredAttachmentsStep:
                this.showFlowComponentDialog(CompleteActivityRequiredAttachmentComponent);
                break;

            case ActivitySuccessResultWithoutDevicesFlowOrder.completeActivitySummaryStep:
                this.initFlowOrderingData(ActivitySuccessResultWithoutDevicesFlowOrder.completeActivitySummaryStep, this.getInstallFlowSummaryData());
                this.showFlowComponentDialog(CompleteActivitySummaryComponent);
                break;

            case ActivitySuccessResultWithoutDevicesFlowOrder.completeActivitySignatureStep:
                this.initFlowOrderingData(ActivitySuccessResultWithoutDevicesFlowOrder.completeActivitySignatureStep, this.getInstallSignatureFlowData());
                this.showFlowComponentDialog(CompleteActivitySignatureContainerComponent);
                break;

            case ActivitySuccessResultWithoutDevicesFlowOrder.saveResults:
                this.saveResults();
                break;

            default:
                this.ngOnDestroy();
                this.continue.emit();
                return;
        }
    }

    showFlowComponentDialog(componentContentType: any, continueEvent: Function = null) {
        let componentData = this.currentComponentData;
        let componentTitle = this.currentComponentTitle;

        let dialogRef = this.dialogService.open({ 
            content: componentContentType, 
            title: componentTitle,
            width: this.appService.isMobileDevice ? '100%' : '100%', 
            height: '100%' 
        });

        let component = dialogRef.content.instance as BaseFlowComponent<typeof componentData>;
        component.data = componentData;
        component.isForwardMovement = this.isForwardMovement;
        component.useImageAnalyze = this.useImageAnalyze;
        component.goToNextEvent.subscribe(() => {
            dialogRef.close();
            this.goToNext();
        });
        component.goToPreviousEvent.subscribe(() => {
            dialogRef.close();
            this.goToPrevious();
        });

        if(continueEvent){
            component.onContinueEvent.subscribe((result) => {
                continueEvent(result);
            });
        }
    }

    get currentComponentData(): any {
        return this.flowOrdering[this.currentOrderIndex].data;
    }

    get currentComponentTitle(): string {
        return this.flowOrdering[this.currentOrderIndex].title;
    }

    get currentOrderNumber(): number {
        return this.currentOrderIndex >= 0 && this.currentOrderIndex < this.flowOrdering.length
            ? this.flowOrdering[this.currentOrderIndex].orderNumber
            : -1;
    }

    getOrderIndexFromOrderNumber(orderNumber: number): number {
        return this.flowOrdering.findIndex(x => x.orderNumber == orderNumber);
    }

    goToPrevious() {
        this.currentOrderIndex--;
        if (this.flowOrdering[this.currentOrderIndex] && this.flowOrdering[this.currentOrderIndex].hide){
            this.goToPrevious();
        }
        this.isForwardMovement = false;
        this.openFlowComponent();
    }

    goToNext() {
        this.currentOrderIndex++;
        if (this.flowOrdering[this.currentOrderIndex] && this.flowOrdering[this.currentOrderIndex].hide){
            this.goToNext();
        }
        this.isForwardMovement = true;
        this.openFlowComponent();
    }

    // Данные компонента 'Результат работ'
    getCompleteActivityResultPropertiesData(): CompleteActivityResultPropertiesData {
        let data = new CompleteActivityResultPropertiesData;
        data.activity = this.activity;
        data.activityResults = this.activityResults;
        data.unsetBIOReasons = this.unsetBIOReasons;
        data.requireSetBIO = this.request.requireSetBIO;
        data.setBIO = this.request.setBIO;
        data.unsetBIOReason = this.request.unsetBIOReason;
        return data;
    }

    getInstallSignatureFlowData(): CompleteActivitySignatureContainerData {
        let activityResultData = this.flowOrdering.find(x =>
                    x.orderNumber == ActivitySuccessResultWithoutDevicesFlowOrder.completeActivitySignatureStep).data as CompleteActivitySignatureContainerData;
        activityResultData = activityResultData != null ? activityResultData : new CompleteActivitySignatureContainerData;
        activityResultData.requestId = this.request.requestId;
        activityResultData.activityId = this.activity.activityId;
        return activityResultData;
    }

    // Данные компонента 'Фото документов'
    getCompleteActivityRequiredAttachmentData(attachmentTypeId: number): CompleteActivityRequiredAttachmentData {
        let data = new CompleteActivityRequiredAttachmentData;
        data.requestId = this.request.requestId;
        data.activityId = this.activity.activityId;
        data.attachmentTypeId = attachmentTypeId;
        data.attachmentTypeName = this.attachmentTypes.find(x => x.id == attachmentTypeId).name;
        data.attachments = this.getFiles(attachmentTypeId, null);
        return data;
    }

    addRequiredAttachmentFlowComponent(attachmentTypeId: number) {
        let flowOrderingItem = {
            orderNumber: ActivitySuccessResultWithoutDevicesFlowOrder.requiredAttachmentsStep,
            data: this.getCompleteActivityRequiredAttachmentData(attachmentTypeId),
            title: "Фото документов"
        };
        let orderIndex = this.getOrderIndexFromOrderNumber(flowOrderingItem.orderNumber);
        this.flowOrdering.splice(orderIndex, 0, flowOrderingItem);
    }

    // Данные компонента 'Резюме'
    getInstallFlowSummaryData() {
        let summary = new CompleteActivitySummaryData;

        summary.requestId = this.request.requestId;
        summary.activityId = this.activity.activityId;
        let activityResultData = this.flowOrdering.find(x =>
            x.orderNumber == ActivitySuccessResultWithoutDevicesFlowOrder.completeActivityResultStep).data as CompleteActivityResultPropertiesData;
        summary.activityResultIds = activityResultData.activityResultIds;
        summary.activityResultName =  this.activityResults.filter(x => summary.activityResultIds.some(i => i == x.id)).map((x) => x.name).join("; ");
        summary.completedDateTime = activityResultData.completedDateTime;
        summary.comment = activityResultData.activity.finishActivityComment;
        summary.activityWorkflowTransitionId = this.activityWorkflowTransitionId;

        summary.uninstallGeneralDevices = summary.uninstallGeneralDevices.filter(x => x != null);
        summary.uninstallSimcardDevices = summary.uninstallSimcardDevices.filter(x => x != null);

        let installGeneralEquipments: SummaryGeneralDevice[] = [];
        summary.installGeneralDevices = installGeneralEquipments.filter(x => x != null);

        let devicesToInstall = summary.installGeneralDevices.map(x => {
            return {
                serialNumber: x.serialNumber,
                nomenclature: x.nomenclature
            } as DeviceInfo;
        });
        summary.installSimcardDevices.forEach(x => {
            devicesToInstall.push({
                serialNumber: x.iccid,
                nomenclature: x.nomenclature
            } as DeviceInfo);
        });
        summary.devicesToInstall = devicesToInstall;

        return summary;
    }

    saveResults() {
        let dialogRef = this.dialogService.open({ 
            content: CompleteActivitySavingResultComponent, 
            title: 'Сохранение результатов',
            width: this.appService.isMobileDevice ? '100%' : '100%', 
            height: '100%' 
        });

        let saveChangesComponent = dialogRef.content.instance as CompleteActivitySavingResultComponent;

        let signatureData = this.flowOrdering.find(x =>
            x.orderNumber == ActivitySuccessResultWithoutDevicesFlowOrder.completeActivitySignatureStep).data as CompleteActivitySignatureContainerData;
        let summary = this.getInstallFlowSummaryData();

        let model = new CompleteActivityWithoutDevicesModel();
        model.requestId = summary.requestId;
        model.activityId = summary.activityId;
        model.comment = summary.comment;
        model.finishDateFact = summary.completedDateTime;
        model.activityResultIds = summary.activityResultIds;
        model.activityWorkflowTransitionId = summary.activityWorkflowTransitionId;
        model.newActivityStatusId = this.nextActivityStatusId;

        model.merchantMemberName = signatureData.merchantMember;
        model.merchantMemberEmail = signatureData.merchantEmail;

        this.activitiesService.completeActivityWithoutDevices(model)
            .subscribe((resp) => {
                if (resp.isSuccessful) {
                    dialogRef.close();
                    this.goToNext();
                } else {
                    this.notificationService.error({
                        title: 'Ошибка при успешном завершении активности',
                        message: resp.errorDescription,
                        notificationType: NotificationType.Toast
                    });
                    dialogRef.close();
                    this.goToPrevious();
                }
            });
    }

    // вспомогательные методы
    private removeLastDefaultItem(orderNumber: number) {
        for (let i = this.flowOrdering.length - 1; i >= 0; i--) {
            if (this.flowOrdering[i].orderNumber === orderNumber) {
                this.flowOrdering.splice(i, 1);
                break;
            }
        }  
    }

    private initFlowOrderingData(flowOrderNumber: number, data: any) {
        this.flowOrdering
            .filter(x => x.orderNumber == flowOrderNumber)
            .forEach(x => x.data = data);
    }

    private getFiles(attachmentTypeId: number, requestDeviceId: number = null) {
        if (requestDeviceId){
            return this.activity.attachments
            .filter(attachment => 
                attachment.attachmentTypeIds.includes(attachmentTypeId) &&
                attachment.requestDeviceId == requestDeviceId &&
                this.uploadedFiles.find(x => x.uid == attachment.attachmentId.toString()) != null)
            .map(attachment => {
                return this.uploadedFiles.find(x => x.uid == attachment.attachmentId.toString());
            });
        } else {
            return this.activity.attachments
            .filter(attachment => 
                attachment.attachmentTypeIds.includes(attachmentTypeId) &&
                this.uploadedFiles.find(x => x.uid == attachment.attachmentId.toString()) != null)
            .map(attachment => {
                return this.uploadedFiles.find(x => x.uid == attachment.attachmentId.toString());
            });
        }
    }

    async loadFileData(attachment: Attachment) { 
        let file = new UploadFileData;
        file.uid = attachment.attachmentId.toString();
        file.fileName = attachment.attachmentName;
        file.fileSize = attachment.attachmentSize;
        file.fileExtension = attachment.attachmentExtension;
        file.isUploadedOnServer = true;

        let blob = await this.attachmentsService.getAttachmentById(attachment.attachmentId).toPromise();
        var reader = new FileReader();
        reader.readAsDataURL(blob); 
        reader.onloadend = function() {
            file.fileData = (reader.result as string).split(',')[1];
        }

        return file;
    }

    hideComponent(order: number, hide: boolean = false) {
        var components = this.flowOrdering.filter(x => x.orderNumber == order);

        if (components.length == 0) 
            return;

        components.forEach(x => x.hide = hide);
    }
}